import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { OrdersServices } from "../services";
import { TakeawayServices } from '../../takeaway/services';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { OrdersCoServices } from '../../orders/services';
import { PrintServices } from '../../services/printServices';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { DishServices } from '../../dish/services';
import { ProductsServices } from '../../products/services';
import { Uploads } from '../../services/uploads';
import { AnalyticsServices } from '../../services/analyticsServices';

/**
 * Generated class for the InvoicesListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-kitchen-order-tags',
  templateUrl: 'kitchen-order-tags.html',
})
export class KitchenOrderTagsPage {

  open_recipe: boolean = false;
  dish: any;
  product: any;
  dishes: any;
  products: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public ordersServices: OrdersServices,
    private takeawayServices: TakeawayServices,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    public ordersCoServices: OrdersCoServices,
    private printServices: PrintServices,
    public alertCtrl: AlertController,
    private dishServices: DishServices,
    private productsServices: ProductsServices,
    private uploadServices: Uploads,
    private analyServices: AnalyticsServices) {

    this.initDishesProducts();
  }

  ionViewWillEnter() {
    //this.initDishesProducts();
  }

  ionViewWillLeave() {
    this.ordersServices.orders_list_filtered_by_tags = [];
  }

  async initDishesProducts() {
    this.dishes = await this.dishServices.getDishes(this.globals.restaurant_uid);
    this.products = await this.productsServices.getProducts(this.globals.restaurant_uid);
  }

  showOrHideOrder(order) {
    if (this.ordersServices.orders_hidden_array) {
      var index = this.ordersServices.orders_hidden_array.findIndex(x => x.order_uid == order.UID);
      if (index >= 0) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  async hideOrder(order) {
    //insert ocultar
    await this.ordersServices.insertOrderHidden(this.globals.restaurant_uid, order.UID, this.globals.user_uid);
  }

  getPersonsOrCustomer(order, type) {
    var index = this.takeawayServices.tables_array_tk_kitchen.findIndex(x => x.UID == order.table_uid);
    if (type === 'table') {
      if (index >= 0) {
        return this.takeawayServices.tables_array_tk_kitchen[index].persons;
      }
    } else {
      if (index >= 0) {
        return this.takeawayServices.tables_array_tk_kitchen[index].customer_name;
      }
    }
  }

  changeFinish(order_uid, index_section, index_section_html, index_element, index_element_html) {
    //Funcion que cambia el estado de un elemento en una seccion
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: '',
      duration: 1000
    });
    loadingPopup.present();

    //Si el indice de seccion es undefined, es porque no se filtran los tags y no tiene el valor.
    if (index_section == undefined) {
      index_section = index_section_html;
    }
    //Si el indice de elemento es undefined, es porque no se filtran los tags y no tiene el valor.
    if (index_element == undefined) {
      index_element = index_element_html;
    }

    //Recuperamos el indice de la orden en la array original
    var index_order = this.ordersServices.orders_array.findIndex(x => x.UID === order_uid);

    var preparation = false;
    var finish = false;

    //ongoing
    this.ordersServices.orders_array[index_order].sections[index_section].ongoing = false;
    //Modifica estado del elemento
    var _finish = this.ordersServices.orders_array[index_order].sections[index_section].list[index_element].finish;
    if (_finish == '' || _finish == 'wait') {
      this.ordersServices.orders_array[index_order].sections[index_section].list[index_element].finish = 'preparation';
      //
      this.prepareAndLaunchSetLog(index_order, index_section, index_element, 'preparation');
      preparation = true;
    } else if (_finish == 'preparation') {
      //
      this.ordersServices.orders_array[index_order].sections[index_section].list[index_element].finish = 'finished';
      this.prepareAndLaunchSetLog(index_order, index_section, index_element, 'finished');
      finish = true;
    }


    this.ordersServices.update(this.ordersServices.orders_array[index_order]);

    if (this.ordersServices.orders_array[index_order].view_date != undefined) {
      preparation = false;
    }
    if  (this.ordersServices.orders_array[index_order].finish_date != undefined) {
      finish = false; 
  }

  if (preparation ) {


    //upadate order
    this.ordersServices.afs.collection('orders').doc(order_uid).update({
      view_date: new Date(),
    });
  } else if (finish) {

    //mirar si todos los elementos de la orden estan finished
    var all_finished = true;
    //contar todos los elementos de la orden
    var count_elements = 0;
    //recorrer this.ordersServices.orders_array[index_order].sections 
    this.globals.objectToArray(this.ordersServices.orders_array[index_order].sections).forEach((item, index_section) => {
      //recorrer this.ordersServices.orders_array[index_order].sections[index_section].list
      this.globals.objectToArray(item.list).forEach((element, index_element) => {
        
        if (element.finish !== 'finished') {
          if(!item.only_combo )   {
              all_finished = false;
          } 
      }
      if (!item.only_combo) {
          count_elements++;
      } 
          

      }
      );
    });

    if (all_finished) {
      //this.ordersServices.orders_array[index_order].finish_date = new Date();
      this.ordersServices.afs.collection('orders').doc(order_uid).update({
        finish_date: new Date(),
      });


      //insertar en analytics
      var _order = {
        "uid": this.ordersServices.orders_array[index_order].UID_RESTAURANT ,//uid_restaurant
        "uid_doc": this.ordersServices.orders_array[index_order].UID,//uid del documento en firebase
        "total_elements": count_elements,//total de elementos de la order
        "user_name": this.globals.user_name, //nombre del usuario que a acabado la comanda
        "type_type": this.ordersServices.orders_array[index_order].type,//el type para el switch de cloud funtions
        "date": new Date()
      };
      this.analyServices.kitchenOrders(_order);
    }


  }

  }

  prepareAndLaunchSetLog(index, index_section, index_element, state) {


    var order = this.ordersServices.orders_array[index];
    var type = '';
    if (order.type == 'table') {
      type = 'table';
      var index = this.takeawayServices.tables_array_tk_kitchen.findIndex(x => x.UID == order.table_uid);
      if (index >= 0) {
        var persons = this.takeawayServices.tables_array_tk_kitchen[index].persons;
      }
    } else {
      type = 'takeaway';
    }

    var variations = true;
    if (this.globals.objectToArray(order.sections[index_section].list[index_element].variations).length > 0) {
      variations = true;
    } else {
      variations = false;
    }

    var extra = {};
    if (order.type == 'table') {
      extra = {
        "order_uid": order.UID,
        "minutes": moment().diff(moment(new Date(order.date.toDate())), 'minutes'),
        "date": new Date(),
        "state": state,
        "section": order.sections[index_section].name,
        "variations": variations,
        "type": type,
        "persons": persons,
      };
    } else {
      extra = {
        "order_uid": order.UID,
        "minutes": moment().diff(moment(new Date(order.date.toDate())), 'minutes'),
        "date": new Date(),
        "state": state,
        "section": order.sections[index_section].name,
        "variations": variations,
        "type": type,
      };
    }

    //send
    this.globals.dataSet('kitchen_element_change_state', order.sections[index_section].list[index_element].name, '', JSON.stringify(extra), '');//Send dish data

  }

  async openRecipe(name) {
    if (!this.open_recipe) {
      //init
      //var dishes = await this.dishServices.getDishes(this.globals.restaurant_uid);
      //var products = await this.productsServices.getProducts(this.globals.restaurant_uid);

      if (!this.dishes || !this.products) {//no han cargad aun los datos toast
        let toast = this.toastCtrl.create({
          message: this.translate.instant('instant-cargando-platos-productos'),
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      } else {//datos cargados
        this.dish = null;
        this.product = null;

        //IF DISH
        var index_dish = this.findDish(name);
        //si existe
        if (index_dish >= 0) {
          this.dish = this.dishes[index_dish];
          this.getImageUrl(this.dish.image, 'dish');
        }
        //IF PRODUCT
        var index_product = this.findProduct(name);
        //si existe
        if (index_product >= 0) {
          this.product = this.products[index_product];
          this.getImageUrl(this.product.image, 'product');
        }
        //
        if (!this.dish && !this.product) {
          this.open_recipe = false;
        } else {
          this.open_recipe = true;
        }
      }
    } else {
      this.open_recipe = false;
    }
  }

  closeCol(order_uid, order) {
    //Funcion que busca si tiene la seccion en la comanda. Si no tiene la seccion elimina la columan en la pantalla
    var _found = false;

    for (let _section of this.ordersServices.select_show) {
      order.sections.forEach((item, index) => {
        //
        /*if (item.name == _section.name && _section.active) {
          _found = true;
        
        item.list.forEach(elem => {
          elem.tags.forEach(tag =>{
            var index = this.ordersCoServices.elements_tags.findIndex(element => element.name == tag.toLowerCase());
            if(this.ordersCoServices.elements_tags[index].active){
              _found = true;
            }
          });
        });}*/
      });
    }

    //Si no lo encontramos lo eliminamos de la pantalla
    if (!_found) {
      var _doc = document.getElementById('kitchen-col-' + order_uid);
      if (_doc != null) {
        _doc.style.display = 'none';
      }
    }
  }

  getDeliveryImage(_delivery) {
    if (_delivery != undefined) {
      const delivery = this.takeawayServices.deliveries.find(t => t.name == _delivery);
      if (delivery != undefined) {
        return delivery.img;
      }
    }
  }

  async print(order) {
    //indv
    if (this.globals.restaurant.printer_type == 'native') {
      order.customer_name = this.getPersonsOrCustomer(order, 'tk');
      order.persons = this.getPersonsOrCustomer(order, 'table');
      this.ordersCoServices.order_kitchen_order = order;
      this.ordersCoServices.order_kitchen_sections = this.globals.objectToArray(order.sections);
      this.ordersCoServices.kitchen_filter = 'tags';
      this.globals.print_content = document.getElementById('print_order');

      var interval = setInterval(() => {
        this.printServices.printNow('print_order');
        clearInterval(interval);
      }, 1000);
    } else {
      //enviar todas las ordenes
      this.printServices.prepareOrderKitchen('kitchen', order, order, this.globals.restaurant.printer_type, 'tags');
    }
  }

  askDeleteOrder(order) {
    const confirm = this.alertCtrl.create({
      title: this.translate.instant('general-eliminar-orden'),
      message: this.translate.instant('general-seguro-quieres-elimnar-orden'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.deleteOrder(order);
          }
        }
      ]
    });
    confirm.present();
  }

  async deleteOrder(order) {
    this.ordersServices.afs.collection('orders').doc(order.UID).delete();
    //Actualizamos las orders
    await this.ordersServices.getOrdersShow(this.globals.restaurant_uid);
  }

  findDish(name) {

    if (this.dishes.findIndex(x => x.name_es == name) >= 0) {
      return this.dishes.findIndex(x => x.name_es == name);
    } else if (this.dishes.findIndex(x => x.name_en == name) >= 0) {
      return this.dishes.findIndex(x => x.name_en == name);
    } else if (this.dishes.findIndex(x => x.name_ca == name) >= 0) {
      return this.dishes.findIndex(x => x.name_ca == name);
    } else if (this.dishes.findIndex(x => x.name_de == name) >= 0) {
      return this.dishes.findIndex(x => x.name_de == name);
    } else if (this.dishes.findIndex(x => x.name_fr == name) >= 0) {
      return this.dishes.findIndex(x => x.name_fr == name);
    } else if (this.dishes.findIndex(x => x.name_it == name) >= 0) {
      return this.dishes.findIndex(x => x.name_it == name);
    }
  }

  findProduct(name) {
    if (this.products.findIndex(x => x.name == name) >= 0) {
      return this.products.findIndex(x => x.name == name);
    } else if (this.products.findIndex(x => x.name_en == name) >= 0) {
      return this.products.findIndex(x => x.name_en == name);
    } else if (this.products.findIndex(x => x.name_ca == name) >= 0) {
      return this.products.findIndex(x => x.name_ca == name);
    } else if (this.products.findIndex(x => x.name_de == name) >= 0) {
      return this.products.findIndex(x => x.name_de == name);
    } else if (this.products.findIndex(x => x.name_fr == name) >= 0) {
      return this.products.findIndex(x => x.name_fr == name);
    } else if (this.products.findIndex(x => x.name_it == name) >= 0) {
      return this.products.findIndex(x => x.name_it == name);
    }
  }

  getImageUrl(image_ref, origen) {
    this.dishServices.image_url_dish_view = null;
    this.productsServices.image_url_product_view = null;
    if (origen === 'dish') {
      if (image_ref) {
        const ref = this.uploadServices.storage.ref(image_ref);
        this.dishServices.image_url_dish_view = ref.getDownloadURL();
      }
    } else {
      if (image_ref) {
        const ref = this.uploadServices.storage.ref(image_ref);
        this.productsServices.image_url_product_view = ref.getDownloadURL();
      }
    }

  }

  callWaiter(order) {
    if (this.globals.checkLimitsByLicense('kitchen', 'notify_waiter')) {//miramos los limites de la licencia
      this.ordersServices.callWaiter(order);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/kitchen/kitchen-order-tags/kitchen-order-tags.ts